/*
 * Copyright (C) 2020 Graylog, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the Server Side Public License, version 1,
 * as published by MongoDB, Inc.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * Server Side Public License for more details.
 *
 * You should have received a copy of the Server Side Public License
 * along with this program. If not, see
 * <http://www.mongodb.com/licensing/server-side-public-license>.
 */
import React, { useEffect, useState } from 'react';

import { getFullVersion } from 'util/Version';
import { SystemStore } from 'stores/system/SystemStore';
import useProductName from 'brand-customization/useProductName';
import useSystemDetails from 'hooks/useSystemDetails';

type Jvm = {
  info: string;
};

const StandardFooter = () => {
  const productName = useProductName();
  const [jvm, setJvm] = useState<Jvm | undefined>();
  const system = useSystemDetails();

  useEffect(() => {
    let mounted = true;

    SystemStore.jvm().then((jvmInfo) => {
      if (mounted) {
        setJvm(jvmInfo);
      }
    });

    return () => {
      mounted = false;
    };
  }, []);

  return !(system && jvm) ? (
    <>
      {productName} {getFullVersion()}
    </>
  ) : (
    <>
      {productName} {system.version} on {system.hostname} ({jvm.info})
    </>
  );
};

export default StandardFooter;
